<div class="sample-sheet-errors">
  <div *ngFor="let section of groupedErrors | keyvalue" class="error-group">
    <div class="section-title">[{{ section.key }}]</div>
    <div *ngFor="let error of section.value" class="error-item">
      <div class="error-icon-message">
        <p>
          <span *ngIf="error.entry" class="error-entry">{{ error.entry }}</span>
          <span class="error-message">{{ error.message }}</span>
        </p>
      </div>
    </div>
  </div>
</div>